<h6 class="u-color-muted u-margin-bottom-half">{{ 'OFFICES.LABEL' | translate }}</h6>
<smvd-ui-locations-input [width]="width" [formControl]="control"></smvd-ui-locations-input>
